<template>
 <el-dialog
      v-if="previewShow"
      title="预览"
      :visible.sync="previewShow"
      append-to-body
      width="90%"
       v-loading="loading"
    >
      <div class="home">
        <div ref="file"></div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" plain @click="previewShow = false"
          >关 闭</el-button
        >
      </span>
    </el-dialog>
</template>
<script>
import axios from 'axios'
const docx = require('docx-preview');
window.JSZip = require('jszip')
export default {
  name: 'Embedded',
  data() {
    return {
      src: '',
      previewShow:false,
      loading: true
    };
  },
  watch:{
  },
  mounted(){

  },
  methods: {
    loadFromUrl() {
     axios({
        method: 'get',
        responseType: 'blob', // 设置响应文件格式
        url:this.src,
      }).then(({data}) => {
        console.log(data);
        docx.renderAsync(data,this.$refs.file) // 渲染到页面预览
         this.loading= false
      })}
  }
}
</script>

<style scoped>

</style>
